import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StaticDataService {

  private deptAndRoles = [
    {'dept': 'Admin', 'roles': ['Super Admin', 'Admin']},
    {'dept': 'CXO', 'roles': ['Manager']},
    {'dept': 'Accounts', 'roles': ['Manager', 'Executive']},
    {'dept': 'Support', 'roles': ['Manager', 'Executive']},
    {'dept': 'Tech', 'roles': ['Manager', 'Executive']},
  ];

  constructor() { }

  getDepts() {
    return this.deptAndRoles;
  }
}
